import { atom } from "jotai";

export const selectedScenariosAtom = atom<number[]>([]);
